import BaseService from './base.service';

const baseService = new BaseService('schoolGroup');

export default {
  getAll: () => baseService.get('findList'),

  getSchoolGroups: () => baseService.get('findList'),

  findList: async () => {
    const { data, status } = await baseService.get('findList');
    if (status === 200) {
      return data;
    }
    throw new Error('Error fetching school groups');
  },
};
